var CredentialsSerialiser = require('services/authentication/credentials-serialiser');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        var principal = Codec.readString(input);
        var credentials = CredentialsSerialiser.read(input);
    },
    write : function(output, req) {
        Codec.writeString(output, req.principal);
        CredentialsSerialiser.write(output, req.credentials);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/change-principal/change-principal-request-serialiser.js
// module id = 1054
// module chunks = 1